export enum Steps {
	registrationDashboard = 0,
	Lookingfor = 1,
	Register = 2,
	Quiz = 3,
	Payment = 4,
	Profile = 5
}
